module.exports = __webpack_public_path__ + "img/button-HastDuBilder_narrow.46398364.jpg";